module.exports = __webpack_public_path__ + "static/media/google-play-badge.06dd5077.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/store-logos/google-play-badge.png
// module id = 220
// module chunks = 0